export default "__VITE_ASSET__BYQIRCw2__"